import { Bounds, Box, Html, OrbitControls, Text, Text3D } from "@react-three/drei";
import { Text as TroikaText } from 'troika-three-text'
import { Canvas, extend, useThree } from "@react-three/fiber";
import { useEffect, useRef } from "react";

extend({ TroikaText });

export function WegetThreeCanvas({
    fitedBoxs
}) {
    const axesHelperRef = useRef();
    const pallet = {
        width: 1.1,
        depth: 1.1,
        height: 0.15,
    }

    // return (
    //     <Canvas style={{ height: 400, width: 400 }}>
    //         <pointLight position={[5, 5, 5]} />
    //         <mesh position={[2,2,2]}>
    //             <boxGeometry args={[1.1, 0.15, 1.1]} />
    //             {/* TroikaText로 텍스트 추가 */}
    //             <troikaText
    //                 position={[0, 0, pallet.depth / 2 + 0.01]} // 텍스트 위치 지정
    //                 text={'Front'}      // 텍스트 내용 설정
    //                 fontSize={0.1}                      // 텍스트 크기
    //                 color="black"                       // 텍스트 색상
    //                 anchorX="center"                    // 텍스트 수평 정렬
    //                 anchorY="middle"                    // 텍스트 수직 정렬
    //             />
    //             <troikaText
    //                 position={[0, 0, -pallet.depth / 2 - 0.01]} // 텍스트 위치 지정
    //                 rotation={[0, Math.PI, 0]}
    //                 text={'Back'}      // 텍스트 내용 설정
    //                 fontSize={0.1}                      // 텍스트 크기
    //                 color="black"                       // 텍스트 색상
    //                 anchorX="center"                    // 텍스트 수평 정렬
    //                 anchorY="middle"                    // 텍스트 수직 정렬
    //             />
    //             {/* 왼쪽 면 */}
    //             <troikaText
    //                 position={[-pallet.width / 2 - 0.01, 0, 0]}
    //                 rotation={[0, Math.PI*1.5, 0]}
    //                 text={'Left'}      // 텍스트 내용 설정
    //                 fontSize={0.1}                      // 텍스트 크기
    //                 color="black"                       // 텍스트 색상
    //                 anchorX="center"                    // 텍스트 수평 정렬
    //                 anchorY="middle"                    // 텍스트 수직 정렬
    //             />

    //             {/* 오른쪽 면 */}
    //             <troikaText
    //                 position={[pallet.width / 2 + 0.01, 0, 0]}
    //                 rotation={[0, Math.PI*2.5, 0]}
    //                 text={'Right'}      // 텍스트 내용 설정
    //                 fontSize={0.1}                      // 텍스트 크기
    //                 color="black"                       // 텍스트 색상
    //                 anchorX="center"                    // 텍스트 수평 정렬
    //                 anchorY="middle"                    // 텍스트 수직 정렬
    //             />

    //             {/* 윗면 */}
    //             <troikaText
    //                 position={[0, pallet.height / 2 + 0.01, 0]}
    //                 rotation={[Math.PI*1.5, 0, 0]}
    //                 text={'Top'}      // 텍스트 내용 설정
    //                 fontSize={0.1}                      // 텍스트 크기
    //                 color="black"                       // 텍스트 색상
    //                 anchorX="center"                    // 텍스트 수평 정렬
    //                 anchorY="middle"                    // 텍스트 수직 정렬
    //             />
    //             <troikaText
    //                 position={[0, -pallet.height / 2 - 0.01, 0]}
    //                 rotation={[-Math.PI*1.5, 0, 0]}
    //                 text={'Bottom'}      // 텍스트 내용 설정
    //                 fontSize={0.1}                      // 텍스트 크기
    //                 color="black"                       // 텍스트 색상
    //                 anchorX="center"                    // 텍스트 수평 정렬
    //                 anchorY="middle"                    // 텍스트 수직 정렬
    //             />
    //         </mesh>
    //         <OrbitControls />
    //     </Canvas>
    // );

    return (
        <>
            <div style={{ width: '100%', height: '500px' }}>
                <Canvas>
                    {/* <MoveCamera /> */}
                    <OrbitControls autoRotate={false} />

                    <mesh
                        position={[pallet?.width / 2, -pallet?.height / 2, pallet?.depth / 2]}
                    >
                        <boxGeometry args={[1.15, 0.15, 1.15]} />
                        <meshStandardMaterial attach={"material"} color={0xffffff} />
                    </mesh>
                    {fitedBoxs?.map((fitedBox, index) => {
                        const subItem = fitedBox?.loadItem;
                        const itemName = `${subItem?.productName}\n${subItem?.optionName}`;

                        let boxSizeX = fitedBox?.width / 100000000;
                        let boxSizeY = fitedBox?.height / 100000000;
                        let boxSizeZ = fitedBox?.depth / 100000000;

                        let positionX = fitedBox?.position[0] / 100000000;
                        let positionY = fitedBox?.position[1] / 100000000;
                        let positionZ = fitedBox.position[2] / 100000000;

                        let d;
                        let positionD;
                        switch (fitedBox.rotationType) {
                            case 0:
                                d = [boxSizeX, boxSizeY, boxSizeZ];
                                break;
                            case 1:
                                d = [boxSizeY, boxSizeX, boxSizeZ];
                                break;
                            case 2:
                                d = [boxSizeY, boxSizeZ, boxSizeX];
                                break;
                            case 3:
                                d = [boxSizeZ, boxSizeY, boxSizeX];
                                break;
                            case 4:
                                d = [boxSizeZ, boxSizeX, boxSizeY];
                                break;
                            case 5:
                                d = [boxSizeX, boxSizeZ, boxSizeY];
                                break;
                        }

                        return (
                            <mesh
                                key={fitedBox.name}
                                position={[positionX + d[0] / 2, positionZ + d[2] / 2, positionY + d[1] / 2]}
                            >
                                <boxGeometry args={[d[0], d[2], d[1]]} />
                                <meshStandardMaterial attach={"material"} color={getRandomHexColor()} />
                                <troikaText
                                    position={[0, 0, d[1] / 2 + 0.01]} // 텍스트 위치 지정
                                    text={itemName}      // 텍스트 내용 설정
                                    fontSize={0.02}                      // 텍스트 크기
                                    color="white"                       // 텍스트 색상
                                    anchorX="center"                    // 텍스트 수평 정렬
                                    anchorY="middle"                    // 텍스트 수직 정렬
                                />
                                <troikaText
                                    position={[0, 0, -d[1] / 2 - 0.01]} // 텍스트 위치 지정
                                    rotation={[0, Math.PI, 0]}
                                    text={itemName}      // 텍스트 내용 설정
                                    fontSize={0.02}                      // 텍스트 크기
                                    color="white"                       // 텍스트 색상
                                    anchorX="center"                    // 텍스트 수평 정렬
                                    anchorY="middle"                    // 텍스트 수직 정렬
                                />
                                {/* 왼쪽 면 */}
                                <troikaText
                                    position={[-d[0] / 2 - 0.01, 0, 0]}
                                    rotation={[0, Math.PI * 1.5, 0]}
                                    text={itemName}      // 텍스트 내용 설정
                                    fontSize={0.02}                      // 텍스트 크기
                                    color="white"                       // 텍스트 색상
                                    anchorX="center"                    // 텍스트 수평 정렬
                                    anchorY="middle"                    // 텍스트 수직 정렬
                                />

                                {/* 오른쪽 면 */}
                                <troikaText
                                    position={[d[0] / 2 + 0.01, 0, 0]}
                                    rotation={[0, Math.PI * 2.5, 0]}
                                    text={itemName}      // 텍스트 내용 설정
                                    fontSize={0.02}                      // 텍스트 크기
                                    color="white"                       // 텍스트 색상
                                    anchorX="center"                    // 텍스트 수평 정렬
                                    anchorY="middle"                    // 텍스트 수직 정렬
                                />

                                {/* 윗면 */}
                                <troikaText
                                    position={[0, d[2] / 2 + 0.01, 0]}
                                    rotation={[Math.PI * 1.5, 0, 0]}
                                    text={itemName}      // 텍스트 내용 설정
                                    fontSize={0.02}                      // 텍스트 크기
                                    color="white"                       // 텍스트 색상
                                    anchorX="center"                    // 텍스트 수평 정렬
                                    anchorY="middle"                    // 텍스트 수직 정렬
                                />
                                <troikaText
                                    position={[0, -d[2] / 2 - 0.01, 0]}
                                    rotation={[-Math.PI * 1.5, 0, 0]}
                                    text={itemName}      // 텍스트 내용 설정
                                    fontSize={0.02}                      // 텍스트 크기
                                    color="white"                       // 텍스트 색상
                                    anchorX="center"                    // 텍스트 수평 정렬
                                    anchorY="middle"                    // 텍스트 수직 정렬
                                />
                            </mesh>
                        );
                    })}
                    <ambientLight intensity={1} />
                    <directionalLight position={[-1, 0, 1]} intensity={0.5} />
                    {/* <gridHelper args={[100, 100]} /> */}
                    <axesHelper args={[2]} />
                </Canvas>
            </div>
        </>
    );
}

// function MoveCamera() {
//     const { camera } = useThree()

//     useEffect(() => {
//         camera.position.set(2, 2, 5) // 초기 위치 설정
//         camera.lookAt(0, 0, 0) // 바라보는 방향 설정
//     }, [camera])

//     return null
// }

/*
x : box.width, geo.x
y : box.depth, geo.z
z : box.height, geo.y

export const RotationTypeStrings = {
  [RotationType_WHD]: 'RotationType_WHD (w,h,d)', (box.width, box.height, box.depth)
  [RotationType_HWD]: 'RotationType_HWD (h,w,d)',
  [RotationType_HDW]: 'RotationType_HDW (h,d,w)',
  [RotationType_DHW]: 'RotationType_DHW (d,h,w)',
  [RotationType_DWH]: 'RotationType_DWH (d,w,h)',
  [RotationType_WDH]: 'RotationType_WDH (w,d,h)',
};
*/
function getRandomHexColor() {
    const randomInt = Math.floor(Math.random() * 0xFFFFFF); // 0xFFFFFF까지 범위에서 랜덤 숫자 생성
    return `#${randomInt.toString(16).padStart(6, '0')}`;  // 16진수 문자열로 변환하고, 길이를 6자리로 맞춤
}
